import AppSystemResourceListResultModel from '../../generated/types/model/resource/AppSystemResourceListResultModel';

export default class AppSystemResourceListResultViewModel extends AppSystemResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
